<template>
  <multiple_form
    :forms="forms"
    :edit="false"
    :editData="props.editData"
    :disabled="true"
    :submitBtn="false"
  />
</template>
<script setup>
  import { defineProps, defineEmits, computed } from 'vue'
  import multiple_form from '@/components/multiple_form'
  import {
    gender,
    yesOrNot,
    strandedLevel,
    strandedSmsStatus,
    strandedFalseAlarm,
  } from '@/utils/common'
  import { constantToOptions } from '@/utils/format'

  //初始化
  const props = defineProps({
    isEdit: Boolean,
    canEdit: Boolean,
    editData: Object,
    data: Array,
    idField: String,
    disabled: Boolean,
  })
  const emit = defineEmits(['submit'])

  //编辑、新增的表单
  const forms = computed(() => [
    {
      name: '告警信息',
      id: 'warm',
      formItem: [
        {
          type: 'select',
          field: 'level_type',
          options: constantToOptions(strandedLevel),
          label: '等级',
        },
        {
          type: 'input',
          field: 'alarm_time',
          label: '告警时间',
        },
        {
          type: 'select',
          field: 'handle_user_id',
          label: '处理人',
          storeOptions: 'user',
        },
        {
          type: 'input',
          field: 'handled_remark',
          label: '处理结果描述',
        },
        {
          type: 'select',
          field: 'false_alarm',
          label: '是否误报',
          options: constantToOptions(strandedFalseAlarm),
        },
        {
          type: 'select',
          field: 'is_black',
          label: '加入黑名单',
          options: constantToOptions(yesOrNot),
        },
        {
          type: 'input',
          field: 'phones',
          label: '接收短信手机号',
        },
        {
          type: 'select',
          field: 'sms_send',
          label: '短信发送状态',
          options: constantToOptions(strandedSmsStatus),
        },
        {
          type: 'input',
          field: 'sms_error_response',
          label: '发送失败响应',
        },
        {
          type: 'input',
          field: 'sms_content',
          label: '短信内容',
          width: '80vw',
        },
      ],
    },
    {
      name: '来访人员信息',
      id: 'visitor',
      dataInObject: 'application_info',
      formItem: [
        {
          type: 'input',
          field: 'visitor_name',
          label: '姓名',
        },
        {
          type: 'radio',
          field: 'visitor_gender',
          options: constantToOptions(gender),
          label: '性别',
        },
        {
          type: 'input',
          field: 'visitor_nation',
          label: '民族',
        },
        // {
        //   type: 'input',
        //   field: 'visitor_education',
        //   label: '学历',
        // },
        {
          type: 'input',
          field: 'visitor_phone',
          label: '手机号码',
        },
        // {
        //   type: 'radio',
        //   field: 'veteran',
        //   options: constantToOptions(yesOrNot),
        //   label: '退役军人',
        // },
        {
          type: 'input',
          field: 'visitor_company',
          label: '单位',
        },
        {
          type: 'input',
          field: 'visitor_address',
          label: '住址',
        },
        {
          type: 'radio',
          storeOptions: 'personVisitType',
          field: 'visitor_type',
          label: '访客类型',
        },
        {
          type: 'select',
          field: 'visitor_idcard_type',
          storeOptions: 'documentType',
          label: '证件类型',
        },
        {
          type: 'input',
          field: 'visitor_idcard',
          label: '证件号码',
        },
        {
          type: 'input',
          field: 'wx_unionid',
          label: '微信ID',
        },
        {
          type: 'imgUpload',
          field: 'visitor_face_photo',
          label: '来访人员人像图片',
        },
        {
          type: 'imgUpload',
          field: 'visitor_idcard_photo1',
          label: '证件人像面图片',
        },
        {
          type: 'imgUpload',
          field: 'visitor_idcard_photo2',
          label: '证件国徽面图片',
        },
      ],
    },
    {
      name: '来访信息',
      id: 'visit',
      dataInObject: 'application_info',
      formItem: [
        {
          type: 'input',
          field: 'visit_content',
          label: '访问事由',
        },
        {
          type: 'dateRange',
          startField: 'visit_begin_time',
          endField: 'visit_end_time',
          label: '来访/截止时间',
          disabledDate(current, dayjs) {
            return current < dayjs().add(2, 'day').endOf('day')
          },
        },
        {
          type: 'select',
          field: 'visit_area',
          label: '申请园区',
          storeOptions: 'areaType',
        },
        {
          type: 'select',
          field: 'is_delayed',
          label: '延期申请',
          options: constantToOptions(yesOrNot),
        },
        {
          type: 'input',
          field: 'delay_reason',
          label: '延期原因',
        },
      ],
    },

    {
      name: '被访信息',
      id: 'interviewee',
      dataInObject: 'application_info',
      formItem: [
        {
          type: 'input',
          field: 'interviewee_name',
          label: '被访问人',
        },
        {
          type: 'input',
          field: 'interviewee_phone',
          label: '被访问人电话',
        },
        {
          type: 'select',
          field: 'interviewee_depart_id',
          storeOptions: 'dept',
          label: '被访问单位',
        },
      ],
    },
  ])
</script>
